import { Folder, Skill } from "@/types/types";
import {
  FOLDER_ICON,
  SKILL_ICON,
  TEMPLATE_ICON,
} from "../display-icon/artifacts";
import { DisplayName } from "./DisplayName";

export const FolderDisplayName = (props: { folder: Pick<Folder, "name"> }) => {
  return <DisplayName icon={FOLDER_ICON} name={props.folder.name} />;
};

export const TemplateDisplayName = (props: {
  template: Pick<Folder, "name">;
}) => {
  return <DisplayName icon={TEMPLATE_ICON} name={props.template.name} />;
};

export const SkillDisplayName = (props: { skill: Pick<Skill, "name"> }) => {
  return <DisplayName icon={SKILL_ICON} name={props.skill.name} />;
};
